// Tiny event bus for the omnipresent Master Chat widget.
// Any page can call openChat(...) to pop the floating widget open with an
// optional master agent, resource context ("lead:<id>" / "candidate:<id>")
// and a pre-filled prompt — without navigating away from the current page.
//
// The last payload is also buffered: on a full page load a route like
// /app/chat/:masterId may fire openChat() BEFORE the widget has registered
// its listener. The widget drains the buffer on mount via consumePendingChat().
let pending = null;

export function openChat(detail = {}) {
    pending = detail;
    window.dispatchEvent(new CustomEvent("jr:open-chat", { detail }));
}

export function consumePendingChat() {
    const p = pending;
    pending = null;
    return p;
}
